import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    display: inline-block;
`;

export const IconButton = styled.img`
    cursor: pointer;
    padding: 4px;
    width: 24px;
    height: 24px;
`;

export const Menu = styled.ul`
    background: ${props => props.theme.colors.primaryWhite};
    border-radius: 8px;
    border: 1px solid ${props => props.theme.colors.border};
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    list-style: none;
    margin: 0;
    padding: 0;
    min-width: 160px;
`;

export const MenuItem = styled.li`
    padding: 6px 14px;
    cursor: pointer;
    font-size: 10px;
    color: ${props => props.theme.colors.text};
    text-align: left;
    background: transparent;
    border-bottom: 1px solid ${props => props.theme.colors.border};
    transition: background-color 0.2s;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: ${props => props.theme.colors.lighterGray};
    }
`;

// Iconos y OptionTitle ya no se usan, pero los dejamos exportados por compatibilidad
export const OptionIcon = styled.img``;
export const OptionTitle = styled.span``;